module.exports = __webpack_public_path__ + "static/icons/icon-live-8912280a5075c341b1a7186009298df4.svg";